(() => {
  const VAT = 1.21;

  function parseMoney(text) {
    if (!text) return null;
    // "€ 1.234,56" -> 1234.56
    const cleaned = text
      .replace(/\s+/g, " ")
      .replace(/[^\d,.-]/g, "")
      .replace(/\.(?=\d{3}(\D|$))/g, "") // duizendtallenpunten weg
      .replace(",", ".");
    const val = parseFloat(cleaned);
    return Number.isFinite(val) ? val : null;
  }

  function formatEUR(v) {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
    }).format(v);
  }

  function ensureMarkup(outEl) {
    if (!outEl.querySelector("[data-qol-incl]")) {
      outEl.innerHTML = `
        <div data-qol-incl style="font-weight:600;"></div>
        <div data-qol-excl style="font-size:0.85em;color:#666;"></div>
      `;
    }
  }

  // ✅ Pakt per rij de LAATSTE zichtbare prijs in "TOTAAL VARIANT" (niet de doorgestreepte)
  function computeExclFromDiscountedRowTotals() {
    let sum = 0;

    const rows = document.querySelectorAll(".quick-order-list__container tr");
    rows.forEach((row) => {
      const totalCell = row.querySelector("td:last-child");
      if (!totalCell) return;

      // zoek alle tekstnodes in die cel, maar skip alles in <s> (doorgestreept)
      const walker = document.createTreeWalker(totalCell, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const t = node.textContent.trim();
          if (!t) return NodeFilter.FILTER_REJECT;
          if (node.parentElement && node.parentElement.closest("s"))
            return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      });

      let last = null;
      while (walker.nextNode()) {
        const val = parseMoney(walker.currentNode.textContent);
        if (val !== null) last = val;
      }

      if (last !== null) sum += last;
    });

    return sum;
  }

  function start() {
    const outEl = document.querySelector("[data-qol-subtotal]");
    if (!outEl) return;

    ensureMarkup(outEl);

    const inclLine = outEl.querySelector("[data-qol-incl]");
    const exclLine = outEl.querySelector("[data-qol-excl]");
    if (!inclLine || !exclLine) return;

    const container =
      document.querySelector(".quick-order-list__container") ||
      document.querySelector(".quick-order-list");
    if (!container) return;

    let scheduled = false;

    const update = () => {
      scheduled = false;

      const excl = computeExclFromDiscountedRowTotals();
      if (!excl || excl <= 0) {
        inclLine.textContent = "— incl. btw";
        exclLine.textContent = "— excl. btw";
        return;
      }

      const incl = Math.round(excl * VAT * 100) / 100;
      inclLine.textContent = `${formatEUR(incl)} incl. btw`;
      exclLine.textContent = `${formatEUR(excl)} excl. btw`;
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };

    // eerste keer + kleine extra delay (WSH update vaak 2x)
    scheduleUpdate();
    setTimeout(scheduleUpdate, 60);
    setTimeout(scheduleUpdate, 200);

    // observer op de tabel/container (WSH herschrijft HTML)
    const obs = new MutationObserver(() => {
      scheduleUpdate();
      setTimeout(scheduleUpdate, 60);
      setTimeout(scheduleUpdate, 200);
    });
    obs.observe(container, { childList: true, subtree: true, characterData: true });

    // clicks/inputs op +/-
    const delegated = (e) => {
      if (!e.target.closest(".quick-order-list__container") && !e.target.closest(".quick-order-list")) return;
      scheduleUpdate();
      setTimeout(scheduleUpdate, 60);
      setTimeout(scheduleUpdate, 200);
    };
    document.addEventListener("click", delegated, true);
    document.addEventListener("change", delegated, true);
    document.addEventListener("input", delegated, true);
  }

  window.addEventListener("load", start);
})();
